#import "@/components/common/LinkFragment.gql"

fragment ProductListingFeatureFragment on productListingFeature_Entry {
  typeHandle
  heading
  body
  image {
    url
    title
  }
  alt
  cta {
    ...LinkFragment
    ... on HyperLinkInterface {
      element {
        ... on products_Entry {
          sectionHandle
          shopifyHandle
        }
      }
    }
  }
  fullBleed
}
